import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/panda/css';
import { useId } from 'react';
interface PlayerLocationMarkerGraphicProps {
  /** When null, the direction cone is hidden. */
  bearing?: number | null;
  isOffscreen?: boolean;
  offscreenBearing?: number | null;
  name?: string;
  avatar?: string;
  color?: string;
}
export function PlayerLocationMarkerGraphic(t0) {
  const $ = _c(71);
  const {
    bearing: t1,
    isOffscreen: t2,
    offscreenBearing: t3,
    name,
    avatar,
    color
  } = t0;
  const bearing = t1 === undefined ? null : t1;
  const isOffscreen = t2 === undefined ? false : t2;
  const offscreenBearing = t3 === undefined ? null : t3;
  const id = useId();
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      pos: "relative",
      w: "[300px]",
      h: "[300px]",
      color: "brand.primary",
      pointerEvents: "none"
    });
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const wrapper = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      transformOrigin: "center"
    });
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const rotatable = t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = css({
      pos: "absolute",
      top: "[160px]",
      left: "[160px]",
      px: "1.5",
      py: "0.5",
      background: "brand.primary",
      borderRadius: "6",
      boxShadow: "md",
      fontWeight: "medium",
      fontSize: "md",
      lineHeight: "[20px]",
      color: "text.inverse",
      transform: "scale(1)",
      transition: "[all 0.2s ease-in-out]",
      whiteSpace: "nowrap"
    });
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const nameStyle = t6;
  let t7;
  if ($[3] !== color) {
    t7 = color ? {
      color
    } : undefined;
    $[3] = color;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      pos: "absolute"
    });
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== id || $[7] !== isOffscreen) {
    t9 = isOffscreen && <g filter={`url(#filter0_${id})`} className="player-location-marker__glow"><circle cx="150" cy="150" r="43" transform="rotate(-90 150 150)" fill="currentColor" /></g>;
    $[6] = id;
    $[7] = isOffscreen;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== bearing || $[10] !== id || $[11] !== isOffscreen) {
    t10 = bearing !== null && !isOffscreen && <path className={rotatable} style={{
      transform: `rotate(${bearing}deg)`
    }} opacity="0.6" d="M126 94H173L158 150H141L126 94Z" fill={`url(#paint0_${id})`} />;
    $[9] = bearing;
    $[10] = id;
    $[11] = isOffscreen;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <circle opacity="0.3" cx="149.5" cy="150.5" r="28.5" fill="currentColor" className="player-location-marker__circle" />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isOffscreen || $[15] !== offscreenBearing) {
    t12 = isOffscreen && <path d="M149.57 133.501L146.504 136.567L145.57 135.634L149.57 131.634L153.57 135.634L152.637 136.567L149.57 133.501Z" fill="white" className="player-location-marker__arrow" style={{
      transform: `rotate(${offscreenBearing}deg)`,
      transformOrigin: "150px 150px"
    }} />;
    $[14] = isOffscreen;
    $[15] = offscreenBearing;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `filter0_${id}`;
  let t14;
  let t15;
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <feFlood floodOpacity="0" result="BackgroundImageFix" />;
    t15 = <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />;
    t16 = <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur" />;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t14 = $[17];
    t15 = $[18];
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t13) {
    t17 = <filter id={t13} x="47" y="47" width="206" height="206" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t14}{t15}{t16}</filter>;
    $[20] = t13;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const t18 = `paint0_${id}`;
  let t19;
  let t20;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <stop stopColor="currentColor" stopOpacity="0" />;
    t20 = <stop offset="1" stopColor="currentColor" />;
    $[22] = t19;
    $[23] = t20;
  } else {
    t19 = $[22];
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t18) {
    t21 = <linearGradient id={t18} x1="149.5" y1="94" x2="149.5" y2="150" gradientUnits="userSpaceOnUse">{t19}{t20}</linearGradient>;
    $[24] = t18;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  let t22;
  if ($[26] !== t17 || $[27] !== t21) {
    t22 = <defs>{t17}{t21}</defs>;
    $[26] = t17;
    $[27] = t21;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t22 || $[32] !== t9) {
    t23 = <div className={t8}><svg aria-hidden="true" width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">{t9}{t10}{t11}{t12}{t22}</svg></div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t22;
    $[32] = t9;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = css({
      pos: "absolute"
    });
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] !== color || $[36] !== name) {
    t25 = name && <span className={nameStyle} style={color ? {
      background: color
    } : undefined}><span>{name}</span></span>;
    $[35] = color;
    $[36] = name;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  const t26 = `url(#filter1_${id})`;
  let t27;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <circle cx="149.5" cy="150.5" r="8.5" fill="currentColor" />;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== avatar || $[40] !== id) {
    t28 = avatar && <circle cx="149.5" cy="150.5" r="8.5" fill={`url(#image1_${id})`} className="player-location-fixed-marker__avatar" />;
    $[39] = avatar;
    $[40] = id;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <circle cx="149.5" cy="150.5" r="9.25" stroke="white" strokeWidth="1.5" />;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] !== t26 || $[44] !== t28) {
    t30 = <g filter={t26} className="player-location-fixed-marker__dot">{t27}{t28}{t29}</g>;
    $[43] = t26;
    $[44] = t28;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  if ($[46] !== avatar || $[47] !== id) {
    t31 = avatar && <pattern id={`image1_${id}`} patternUnits="objectBoundingBox" width="17" height="17"><image href={avatar} width="17" height="17" preserveAspectRatio="xMidYMid slice" /></pattern>;
    $[46] = avatar;
    $[47] = id;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  const t32 = `filter1_${id}`;
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  let t38;
  let t39;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <feFlood floodOpacity="0" result="BackgroundImageFix" />;
    t34 = <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />;
    t35 = <feOffset />;
    t36 = <feGaussianBlur stdDeviation="2.5" />;
    t37 = <feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.5 0" />;
    t38 = <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />;
    t39 = <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />;
    $[49] = t33;
    $[50] = t34;
    $[51] = t35;
    $[52] = t36;
    $[53] = t37;
    $[54] = t38;
    $[55] = t39;
  } else {
    t33 = $[49];
    t34 = $[50];
    t35 = $[51];
    t36 = $[52];
    t37 = $[53];
    t38 = $[54];
    t39 = $[55];
  }
  let t40;
  if ($[56] !== t32) {
    t40 = <filter id={t32} x="134.5" y="135.5" width="30" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t33}{t34}{t35}{t36}{t37}{t38}{t39}</filter>;
    $[56] = t32;
    $[57] = t40;
  } else {
    t40 = $[57];
  }
  let t41;
  if ($[58] !== t31 || $[59] !== t40) {
    t41 = <defs>{t31}{t40}</defs>;
    $[58] = t31;
    $[59] = t40;
    $[60] = t41;
  } else {
    t41 = $[60];
  }
  let t42;
  if ($[61] !== t30 || $[62] !== t41) {
    t42 = <svg aria-hidden="true" width="300" height="300" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">{t30}{t41}</svg>;
    $[61] = t30;
    $[62] = t41;
    $[63] = t42;
  } else {
    t42 = $[63];
  }
  let t43;
  if ($[64] !== t25 || $[65] !== t42) {
    t43 = <div className={t24}>{t25}{t42}</div>;
    $[64] = t25;
    $[65] = t42;
    $[66] = t43;
  } else {
    t43 = $[66];
  }
  let t44;
  if ($[67] !== t23 || $[68] !== t43 || $[69] !== t7) {
    t44 = <div className={wrapper} style={t7}>{t23}{t43}</div>;
    $[67] = t23;
    $[68] = t43;
    $[69] = t7;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  return t44;
}